/* eslint-disable @typescript-eslint/no-unused-vars */

/** 整形, FromType表示其是从某个类型序列化而来 */
export type int<FromType = any> = number;
/** 无符号整形, FromType表示其是从某个类型序列化而来 */
export type uint<FromType = any> = number;
/** 浮点数, FromType表示其是从某个类型序列化而来 */
export type float<FromType = any> = number;

/** 区间类型, Min 表示最小值, Max 表示最大值，RangeType 表示 左右开闭类型 */
export type t_range<
  Min extends number,
  Max extends number,
  RangeType extends "[)" | "()" | "[]" | "(]"
> = [Min, Max];

/** 表示这个是一个时间戳, 支持两种计时方式 */
export type t_timestamp<Unit extends "ms" | "s" = "ms"> = number;
/** 表示这个是一个UTC字符串 */
export type t_time_str<
  Standard extends "UTCDate" | "UTCDateTime" | "+8DateTime" | "+8Date" | ""
> = string;
/** 表示boolean值的默认值 */
export type t_boolean<DefaultValue extends boolean> = boolean | DefaultValue;
/** 表示字符串是由 FromType 序列化而来的 */
export type t_str<FromType = any> = string;

export enum STAGES {
  AUCTION_NOT_START = 101,
  AUCTION_RUNNING = 1,
  AUCTION_END = 102,
  WL1_RUNNING = 2,
  WL1_END = 103,
  WL2_RUNNING = 3,
  WL2_END = 104,
  PUBLIC_RUNNING = 4,
  PUBLIC_END = 105,
}

export interface MerkleData {
  index: int;
  address: string;
  stage: int;
  proof: string[];
}
export interface MerkleRet {
  merkle1: MerkleData | null;
  merkle2: MerkleData | null;
}

export interface WlData {
  wl1: boolean;
  wl2: boolean;
}
